import React from 'react';
import { Button } from 'reactstrap';

import Notification from './Notifications';

export default class NotificationsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  dismissAll = () => {
    if (this.props.notificationsUnread?.length > 0) {
      this.props.notificationsMessagesSeen(this.props.notificationsUnread);
    }
  };

  render() {
    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-light">
          <h5 className="mb-0">
            <span className="unread-count mr-2">
              {this.props.notificationsUnread.length}
            </span>
            Unread Notifications
          </h5>
          <Button
            color="link"
            onClick={this.dismissAll}
            className="btn-sm m-0 p-0"
          >
            Mark All as Read
          </Button>
        </div>

        <Notification
          notification={this.props.notificationsUnread}
          isRead={false}
          notificationsMessagesSeen={this.props.notificationsMessagesSeen}
        />

        <Notification
          notification={this.props.notificationsRead}
          isRead
          notificationsMessagesSeen={this.props.notificationsMessagesSeen}
        />
      </>
    );
  }
}
